var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnCaretLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 10,
    width: 7.381,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.1 4.8L7 .038a.238.238 0 01.373.2v9.524a.238.238 0 01-.373.2L.1 5.2a.238.238 0 010-.392z"
  })));
}
export default __webpack_public_path__ + "media/icons/icn_caret-left-79acfb46.svg";
export { SvgIcnCaretLeft as ReactComponent };